import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Cards from "../../components/cards/Cards";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { portfolioData, websiteData } from "../../utils/data";

const Destinations = () => {
  useEffect(() => {
    document.title = `Contact Us | ${websiteData.company_name}`;
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Breadcrumbs title="Our Portfolio" pagename="Portfolio" />

      <section className="py-5">
        <Container>
          <Row>
            {portfolioData.map((destination, inx) => {
              return (
                <Col md="3" sm="6" key={inx} className="pb-4">
                  <Cards destination={destination} key={inx} />
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Destinations;
